var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.902 52.846",
    style: {
      enableBackground: "new 0 0 59.902 52.846"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#4FB8C2;}\n\t.st6{fill:#404040;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:none;stroke:#4FB8C2;stroke-miterlimit:10;}\n\t.st9{enable-background:new    ;}\n\t.st10{fill:#303B84;}\n\t.st11{fill:#A7DBE0;}\n\t.st12{fill:none;stroke:#4FB8C2;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#404040;stroke-miterlimit:10;}\n\t.st14{fill:#B3B3B3;}\n\t.st15{fill:#FF3732;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 58.892,
    y1: 31.957,
    x2: 49.84,
    y2: 5.713
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1.01,
    y1: 31.957,
    x2: 10.063,
    y2: 5.713
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.39799,31.99c-0.568,3.602-3.688,6.558-7.448,6.558c-3.787,0-6.922-2.919-7.46-6.558H1v19.856h57.902V31.99 H37.39799z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "43.508,15.521 43.508,9.882 16.395,9.882 16.395,15.522  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "40.92599,5.351 40.92599,1 18.977,1 18.977,5.352  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "46.785,27.432 46.785,20.119 13.118,20.119 13.118,27.431  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.18c65833e5004fddc8e49f7b3b205a0f.svg";
export { ForwardRef as ReactComponent };